// src/api/studios.js
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export const fetchStudios = async () => {
  try {
    const studiosRef = collection(db, 'studios');
    const snapshot = await getDocs(studiosRef);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Erreur lors de la récupération des studios :', error);
    return [];
  }
};
